define([], ()=> {
    return ['$q', 'JsonRPCService', ($q, JsonRPCService)=> {
        return {
            checkAvailabilityBasedOnPostalCode: (callGroups, availabilityRequestDTO)=> {
                const deferred = $q.defer();
                JsonRPCService.send('availability', 'availability', 'isProductAvailableBasedOnPostalCode', [availabilityRequestDTO], callGroups).then(
                    (availabilityResponseDTO)=> {
                        return deferred.resolve(availabilityResponseDTO);
                    }, (error, status, headers)=> {
                        return deferred.reject([error, status, headers]);
                    });
                return deferred.promise;
            },

            checkAvailabilityBasedOnAddress: (callGroups, availabilityRequestDTO)=> {
                const deferred = $q.defer();
                JsonRPCService.send('availability', 'availability', 'isProductAvailableBasedOnAddress', [availabilityRequestDTO], callGroups).then(
                    (response)=> {
                        const availabilityResponseDTO = response;
                        return deferred.resolve(availabilityResponseDTO);
                    }, (error, status, headers)=> {
                        return deferred.reject([error, status, headers]);
                    });
                return deferred.promise;
            }
        };
    }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/policyjob/services/AvailabilityService.js
 **/